import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const painPoints = [{
  title: 'The Costco Trap',
  description: "Buying premium Prime or Wagyu cuts won't fix bad technique. A $100 brisket cooked wrong is just expensive dog food."
}, {
  title: 'The Set-and-Forget Lie',
  description: "YouTube gurus say 'just set it and forget it.' That's how you get shoe leather. Real BBQ requires understanding the environment inside the cooker."
}, {
  title: 'The Gadget Spiral',
  description: "You don't need a $2,000 Traeger or a fancy Wi-Fi thermometer. You need to understand HEAT. Gadgets are crutches for bad fundamentals."
}, {
  title: 'The Sauce Cover-Up',
  description: 'If you need to drown your meat in sweet BBQ sauce to make it edible, something went terribly wrong 4 hours ago.'
}, {
  title: 'The Temperature Myth',
  description: "Internal temp alone doesn't tell you if meat is actually tender and juicy. 203°F means nothing if the collagen hasn't broken down."
}];
export function PainPoints() {
  return <section className="py-16 md:py-20 px-4 bg-dark" data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-156">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-ivory mb-4 uppercase tracking-tight" data-id="element-157">
            🔥 The Painful Truth About Backyard BBQ
          </h2>
        </motion.div>

        <div className="space-y-5" data-id="element-158">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-contrast border border-dark-elevated rounded-xl p-5 md:p-8 flex items-start gap-4 md:gap-6 hover:border-[#333] transition-colors" data-id="element-159">
              <div className="flex-shrink-0 mt-1" data-id="element-160">
                <XCircleIcon className="text-red-600 w-8 h-8" data-id="element-161" />
              </div>
              <div data-id="element-162">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-amber mb-2 md:mb-3 uppercase tracking-tight" data-id="element-163">
                  {point.title}
                </h3>
                <p className="text-smoke leading-relaxed text-base md:text-lg" data-id="element-164">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}